/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Ce } from './Ce';

const { GlobalVar } = Utils;

class SupplementGrouping extends Ce {
    constructor() {
        super();
        this.baseUrl += '/supplementGrouping';
    }

    findSupplementGroupingList({
        verticalGroupingName,
        verticalGroupingSn,
        certCatId,
        certExamType,
        schoolOrgId,
        verticalGroupingStatus,
        verticalGroupingStatusNE,
        insertTime,
        certExamId,
        idNE,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findSupplementGroupingList', {
            verticalGroupingName,
            verticalGroupingSn,
            certCatId,
            certExamType,
            schoolOrgId,
            verticalGroupingStatus,
            verticalGroupingStatusNE,
            insertTimeBegin,
            insertTimeEnd,
            certExamId,
            idNE,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    findSupplementGroupingListWithStat({
        verticalGroupingName,
        verticalGroupingSn,
        certCatId,
        certExamType,
        schoolOrgId,
        verticalGroupingStatus,
        verticalGroupingStatusType,
        insertTime,
        certExamId,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findSupplementGroupingListWithStat', {
            verticalGroupingName,
            verticalGroupingSn,
            certCatId,
            certExamType,
            schoolOrgId,
            verticalGroupingStatus,
            verticalGroupingStatusType,
            insertTimeBegin,
            insertTimeEnd,
            certExamId,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/getDetail', { id }).then(json => {
            const { groupQrCode } = json.data.data.supplementGrouping;
            if (!groupQrCode) {
                json.data.data.supplementGrouping.groupQrCode = [];
            } else {
                json.data.data.supplementGrouping.groupQrCode = groupQrCode.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, verticalGroupingName, verticalGroupingSn, certExamId, schoolOrgId } = {}) {
        return super.post('/save', {
            id,
            verticalGroupingName,
            verticalGroupingSn,
            certExamId,
            schoolOrgId,
        });
    }

    effective({ ids, isCheckTime } = {}) {
        return super.post('/effective', {
            ids,
            isCheckTime,
        });
    }

    certificateMake({ id }) {
        return super.post('/certificateMake', { id });
    }

    complete({ ids } = {}) {
        return super.post('/complete', {
            ids,
        });
    }

    remove({ supplementGroupingId, ids } = {}) {
        return super.post('/remove', {
            supplementGroupingId,
            ids,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    saveSeatNumber({ supplementGroupingId, supplementApplyId, seatNumber }) {
        return super.post('/saveSeatNumber', {
            supplementGroupingId,
            supplementApplyId,
            seatNumber,
        });
    }

    updateFillFormTime({ supplementGroupingId, fillFormTime }) {
        return super.post(
            '/updateFillFormTime',
            {
                supplementGroupingId,
                fillFormTime,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    initSupplementGroupingSeatNumber({ supplementGroupingId }) {
        return super.post('/initSupplementGroupingSeatNumber', { supplementGroupingId });
    }
}

export default new SupplementGrouping();
export { SupplementGrouping };
